// extracted by mini-css-extract-plugin
export default {"post":"Post_post__lBCQo","post__image":"Post_post__image__D-Ays","post__inner":"Post_post__inner__Nd7+P"};